export default "__VITE_ASSET__D4B3qngR__"